export class TestResultComment {
  id: number;
  testRequirementId: number;
  sampleId: number;
  originalComment?: string;
  comment: string;
  isCommentModified: boolean = false;
}
